import { jsx as _jsx } from "react/jsx-runtime";
import ButtonBase from '#pplx/frontend/components/buttons/ButtonBase.js';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
/**
 * @deprecated - Prefer `aether/components/Button` whenever possible. Reach out to #web-design-system for help.
 */
const TextButton = memo(function TextButton({ variant = 'common', noPadding, noXPadding, extraCSS, ...rest }) {
    const buttonClass = useMemo(() => {
        const variantClasses = {
            super: 'hover:bg-soft text-button-bg',
            primary: 'hover:bg-soft text-primary',
            common: 'hover:bg-soft text-secondary hover:text-primary',
            positive: 'text-secondary hover:bg-soft hover:text-super-primary',
            positiveSelected: 'text-super-primary hover:bg-soft hover:text-super-primary',
            negative: 'text-secondary hover:bg-soft hover:text-negative-primary',
            negativeSelected: 'text-negative-primary hover:bg-soft hover:text-negative-primary',
            noBackground: 'text-secondary hover:text-primary',
            noHover: 'text-secondary  cursor-default',
            subtle: 'text-primary bg-soft',
        };
        return classNames('focus-visible:bg-soft', { '!p-0 !h-auto hover:!bg-transparent': noPadding }, { '!px-0 hover:!bg-transparent': noXPadding }, variantClasses[variant], extraCSS);
    }, [extraCSS, variant, noPadding, noXPadding]);
    return _jsx(ButtonBase, { testId: rest.testId, extraCSS: buttonClass, ...rest });
});
export default TextButton;
//# sourceMappingURL=TextButton.js.map